import { doc, getDoc, runTransaction } from 'firebase/firestore';
import { db } from '../firebase';
import {
    APCS2026_VIDEO_PENALTY_CONFIG,
    validateVideoPenaltyConfig,
} from './videoPenaltyRules';

const cloneRules = (rules) => rules.map((rule) => ({ ...rule }));

export const createDefaultVideoPenaltyConfig = (penaltyScore = 5) => ({
    revision: 1,
    penaltyScore: Number.isFinite(Number(penaltyScore)) && Number(penaltyScore) > 0
        ? Number(penaltyScore)
        : 5,
    rules: cloneRules(APCS2026_VIDEO_PENALTY_CONFIG.rules),
});

export const fetchVideoPenaltyConfig = async (eventId) => {
    if (!eventId) return null;
    const eventSnapshot = await getDoc(doc(db, 'events', eventId));
    if (!eventSnapshot.exists()) return null;
    return eventSnapshot.data()?.videoPenaltyConfig || null;
};

export const fetchVideoPenaltyConfigs = async (eventIds) => {
    const uniqueEventIds = [...new Set((eventIds || []).filter(Boolean))];
    const entries = await Promise.all(uniqueEventIds.map(async (eventId) => [
        eventId,
        await fetchVideoPenaltyConfig(eventId),
    ]));
    return Object.fromEntries(entries);
};

export const saveVideoPenaltyConfig = async (eventId, config) => {
    if (!eventId) throw new Error('An event must be selected.');

    const configToSave = {
        penaltyScore: Number(config.penaltyScore),
        revision: 1,
        rules: cloneRules(config.rules),
    };
    const validation = validateVideoPenaltyConfig(configToSave);
    if (!validation.isValid) {
        throw new Error(validation.errors.join(' '));
    }

    const eventRef = doc(db, 'events', eventId);
    return runTransaction(db, async (transaction) => {
        const eventSnapshot = await transaction.get(eventRef);
        const storedRevision = Number(eventSnapshot.data()?.videoPenaltyConfig?.revision) || 0;
        const nextConfig = {
            ...configToSave,
            revision: storedRevision + 1,
        };

        transaction.set(eventRef, { videoPenaltyConfig: nextConfig }, { merge: true });
        return nextConfig;
    });
};
